import { OrgEntitlements } from "../models/SubscriptionModels";
import "./MessagingUsageBar.css";

interface MessagingUsageBarProps {
  entitlements: OrgEntitlements | null;
  compact?: boolean;
}

const MessagingUsageBar = ({
  entitlements,
  compact = false,
}: MessagingUsageBarProps) => {
  if (!entitlements || !entitlements.hasActiveSubscription) return null;

  const limit = entitlements.monthlyMessageLimit;
  const unlimited = limit < 0;
  const used = entitlements.messagesUsedThisMonth;
  const remaining = unlimited ? null : entitlements.messagesRemaining;
  const remainingLabel = unlimited ? "Unlimited" : `${remaining} remaining`;

  return (
    <div
      className={`usage-bar${compact ? " usage-bar--compact" : ""}`}
      title={`${used} of ${unlimited ? "unlimited" : limit} messages used this month`}
    >
      <div className="usage-bar__head">
        <span className="usage-bar__label">
          Messaging usage{" "}
          <span className="usage-bar__count">
            {used}
            {unlimited ? "" : ` / ${limit}`}
          </span>
        </span>
        <span
          className={`usage-bar__remaining${remaining !== null && remaining < used ? " usage-bar__remaining--low" : ""}`}
        >
          {remainingLabel}
        </span>
      </div>
      {!unlimited && (
        <progress
          className="usage-bar__track"
          max={limit}
          value={used}
          aria-label={`${used} of ${limit} messages used`}
        />
      )}
    </div>
  );
};

export default MessagingUsageBar;